module.exports = __webpack_public_path__ + "img/Gallery_2_12.2b0a450c.jpeg";